import { render, staticRenderFns } from "./invoices.vue?vue&type=template&id=26a8c276&scoped=true"
import script from "./invoices.vue?vue&type=script&lang=js"
export * from "./invoices.vue?vue&type=script&lang=js"
import style0 from "./invoices.vue?vue&type=style&index=0&id=26a8c276&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26a8c276",
  null
  
)

export default component.exports